<template>
<div>
  <div class="row qm-foto-list">
    <div v-for="foto in fotos" :class="qmFotoItemClass">
      <img :src="foto.dataUrl" alt="" class="img-thumbnail qm-foto" v-on:click="toggleQmFotoDeleteButton" :key="foto.id">
      <button class="btn btn-turquois qm-foto-delete-button" @click="deleteFoto(foto.id)" type="button" style="display:none;">
        <i class="fa fa-fw fa-trash-o"></i>
      </button>
    </div>
    <div v-if="maxFotosReached" class="qm-foto-upload-button">
      <label for="uploadFile" class="btn btn-turquois ripple"><i class="fa fa-camera"></i></label>
      <input v-on:change="uploadImage" id="uploadFile" type="file" accept="image/*" capture="environment">
    </div>
    <div v-if="maxFotosReached" class="col-12 qm-max-fotos"><i class="fa fa-info-circle"></i> Max {{ maxFotos }} photos</div>
    <div v-else class="col-12 qm-max-fotos qm-max-fotos-reached"><i class="fa fa-exclamation-circle"></i> Max {{ maxFotos }} photos reached</div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import loadImage from 'blueimp-load-image'
import $ from 'jquery'
export default {
  name: 'FotoList',
  data: () => ({
    imgUrl: null
  }),
  props: {
    mode: {
      type: String,
      required: true
    },
    maxFotos: {
      type: Number,
      required: true
    }
  },
  computed: {
    maxFotosReached () {
      return this.fotos.length < this.maxFotos
    },
    startsWith () {
      if (this.mode === 'survey') {
        return 'survey-' + this.session.surveyId
      } else { // item
        return 'item-' + this.session.itemId
      }
    },
    nextFotoStorageKey () {
      if (this.mode === 'survey') {
        return 'survey-' + this.session.surveyId + '-foto-' + this.session.nextFotoId
      } else { // item
        return 'item-' + this.session.itemId + '-foto-' + this.session.nextFotoId
      }
    },
    qmFotoItemClass () {
      if (this.mode === 'survey') {
        return 'col-xl-2 col-lg-4 col-md-6 col-sm-6 col-12 qm-foto-item'
      } else {
        return 'col-xl-12 col-lg-12 col-md-4 col-sm-4 col-12 qm-foto-item'
      }
    },
    ...mapGetters({
      session: 'getSession',
      fotos: 'getAllFotos'
    })
  },
  created: function () {
    this.$store.dispatch('loadSession').then(() => {
      this.$store.dispatch('getAllFotos', this.startsWith)
    })
  },
  methods: {
    uploadImage (e) {
      loadImage(
        e.target.files[0],
        (img) => {
          var dataurl = img.toDataURL('image/jpeg', 0.75)
          this.$set(this.$data, 'imgUrl', dataurl)
          this.storeFoto()
        },
        {
          maxWidth: 1024,
          maxHeight: 1024,
          canvas: true,
          orientation: true
        }
      )
    },
    resizeImage (imgUrl) {
      let component = this
      return new Promise(function (resolve) {
        let img = new Image() // eslint-disable-line no-undef
        let maxWidthHeight = 1024
        // resize the image when it is loaded into the canvas
        img.onload = function () {
          let landscape = this.width >= this.height
          let ratio = this.width / this.height
          let canvas = document.createElement('canvas')
          let ctx = canvas.getContext('2d')
          if (landscape) {
            canvas.width = maxWidthHeight
            canvas.height = canvas.width / ratio
          } else {
            canvas.height = maxWidthHeight
            canvas.width = canvas.height * ratio
          }
          // draw the img into canvas
          ctx.drawImage(this, 0, 0, canvas.width, canvas.height)
          component.imgUrl = canvas.toDataURL('image/jpeg', 0.75) // 2nd arg is jpeg quality from 0 to 1
          resolve()
        }
        // load original image to resize it
        img.src = imgUrl
      })
    },
    storeFoto () {
      if (this.imgUrl !== '') {
        this.resizeImage(this.imgUrl).then(() => {
          let foto = {
            id: this.session.nextFotoId,
            surveyId: this.session.surveyId,
            itemId: (this.mode !== 'survey') ? this.session.itemId : null,
            dataUrl: this.imgUrl
          }
          this.$store.dispatch('storeFoto', { nextFotoStorageKey: this.nextFotoStorageKey, foto: foto }).then(() => {
            this.$store.dispatch('incrementNextFotoId')
          })
        })
      }
    },
    deleteFoto (id) {
      let storageKey = null
      if (this.mode === 'survey') {
        storageKey = 'survey-' + this.session.surveyId + '-foto-' + id
      } else {
        storageKey = 'item-' + this.session.itemId + '-foto-' + id
      }
      if (storageKey !== null) {
        this.$store.dispatch('removeFoto', { identifier: String(storageKey), id: id })
      }
    },
    toggleQmFotoDeleteButton (event) {
      $(event.target).parent().find('.qm-foto-delete-button').toggle()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/children/FotoList.vue